import React from 'react';

import Button from '@components/Button';

interface FooterProps {
  isSubscriber: boolean;
  subscribePromoUrl: string;
}

const Footer = ({ isSubscriber, subscribePromoUrl }: FooterProps) => {
  return (
    <div className="mt-24 flex flex-col items-center justify-center px-16 lg:px-0">
      <div className="text-center font-serif text-headline-lg font-medium text-pro-red md:text-headline-xl">
        Read The Information first...
      </div>
      <div className="text-center font-serif text-headline-lg font-medium">
        or <span className="italic">them</span> later
      </div>
      <div className="text-style body-lg mb-32 text-center font-serif font-normal text-[#545B69] sm:max-w-[520px]">
        The Information is where you go to get the most important news about technology and business
        first.
      </div>
      {!isSubscriber && (
        <Button
          className="text-sans mb-48 mt-8 w-[240px] !text-body-lg !capitalize"
          rounded="slight"
          type="button"
          variant="primary"
          href={subscribePromoUrl}
        >
          Subscribe
        </Button>
      )}
    </div>
  );
};

export default Footer;
